import { ThemeParser } from '../../../core/theme';
import { parseDataZoom } from '../../mobile/component/dataZoom';
import darkDataZoomHandler from '../../../assets/pcDarkDataZoomHandler.png';
import lightDataZoomHandler from '../../../assets/pcLightDataZoomHandler.png';

const PCSliderStyle = {
  light: {
    backgroundColor: '#F5F5F5',
    handleIcon: `image://${lightDataZoomHandler as string}`,
    areaColor: '#EDEDED'
  },
  dark: {
    backgroundColor: '#2B2B2B',
    handleIcon: `image://${darkDataZoomHandler as string}`,
    areaColor: '#333'
  }
};

export function dataZoomThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const [option, chart] = args;
  const themeMode = chart.getModel().getThemeName().includes('light') ? 'light' : 'dark';
  // dataZoom沿用移动端规范
  parseDataZoom(option, themeMode, PCSliderStyle);
}
